export const routes = {
  dashboard: '/dashboard',
  dashboardLk: '/dashboard/lk',
  dashboardSubscription: '/dashboard/subscription',
  dashboardProfile: '/dashboard/profile',
  videos: '/catalog',
  catalogSubscription: '/catalog/subscription',
  videoViewer: '/catalog/videos/:videoUrl',
  videoCollection: '/catalog/collections/:collectionUrl',
  videoCollectionViewer: '/catalog/collections/:collectionUrl/videos/:videoUrl',
  videoViewerLegacy: '/catalog/:videoId',
  admin: '/admin',
  superAdmin: '/super-admin',
  superAdminLogs: '/super-admin/logs',
  superAdminUsers: '/super-admin/users',
  superAdminBubbleMigration: '/super-admin/bubble-migration',
  choosePlan: '/choose-plan',
  onboarding: '/onboarding',
  onboardingOld: '/onboarding-old',
  catalog: '/ui-catalog',
  registration: '/registration',
  academyPricing: '/academy',
  resetPassword: '/reset_pw',
  magicLink: '/magic-link',
  userAgreement: '/legal/user-agreement',
  privacyPolicy: '/legal/privacy-policy',
} as const

export type RoutePath = (typeof routes)[keyof typeof routes]
